import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Tumi/TumiLogo.png'


const _withScopeId = n => (_pushScopeId("data-v-44aa2682"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TumiBackLogin" }
const _hoisted_2 = { class: "TumiLogin" }
const _hoisted_3 = { class: "TumiForm" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "LogoTumi",
  class: "mb-3"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mb-3" }, "Enter your email and we will send you a link to set up a new password", -1))
const _hoisted_6 = { class: "d-grid gap-2" }
const _hoisted_7 = { class: "text-center mt-3" }
const _hoisted_8 = {
  key: 0,
  class: "spinner-border TumiSpinner text-light",
  role: "status"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "TumiErrorLogin" }
const _hoisted_12 = { class: "TumiTextWarning" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _hoisted_4,
          _createElementVNode("div", null, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mail) = $event)),
              placeholder: "Email"
            }, null, 512), [
              [_vModelText, _ctx.mail]
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.SendMail && _ctx.SendMail(...args))),
                class: "btn btn-primary"
              }, "Send email")
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.waiting)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.error), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}